@if (strapiContent$ | async; as strapiContent) {
<div class="component" [innerHtml]="strapiContent">
  <h1 class="headline text--allcaps">Things.<br />What?</h1>
  <p>Introducing the ONEOK Customer Portal, providing information to meet your business needs.</p>
</div>
} @else {

<div class="component">
  <h1 class="headline text--allcaps">DATA.<br />REPORTS.</h1>
  <p>Introducing the ONEOK Customer Portal, providing information to meet your business needs.</p>
</div>

}

<div class="component">
  <div class="box">
    <h2 class="heading">Ready to Log In?</h2>
    <button type="button" [disabled]="$isPending()" [class.is-disabled]="$isPending()" (click)="logOnSecure()">
      <span><strong>See My Data</strong></span>
    </button>
    <section class="group--btns">
      <a
        data-tooltip="If you log in with an email address and need to reset your password, click here"
        [attr.href]="forgotPasswordUrl"
        >I forgot my password</a
      >
      <a [routerLink]="['/onboard']">My company wants access</a>
    </section>
  </div>
  <p class="legal">
    © ONEOK, Inc. All rights reserved&nbsp;|&nbsp;<a
      target="_blank"
      href="https://www.oneok.com/legal-and-privacy"
      class="legal-and-privacy"
      >Legal & Privacy Policy</a
    >
  </p>
</div>
